// import * as React from "react";
// import { BarChart } from "@mui/x-charts/BarChart";

// export default function BarChartSection() {
//   return (
//     <BarChart
//       series={[
//         { data: [35, 44, 24, 34] },
//         { data: [51, 6, 49, 30] },
//         { data: [15, 25, 30, 50] },
//         { data: [60, 50, 15, 25] },
//       ]}
//       height={290}
//       xAxis={[{ data: ["Q1", "Q2", "Q3", "Q4"], scaleType: "band" }]}
//       margin={{ top: 10, bottom: 30, left: 40, right: 10 }}
//     />
//   );
// }

import { Chart } from "react-google-charts";

const data = [
    ["Year", "user", "Expenses", "Profit", "Loss"],
    ["2014", 1000, 400, 2000, 900],
    ["2015", 1170, 460, 3000, 400],
    ["2016", 660, 1120, 500, 100],
    ["2017", 1030, 540, 200, 0],
];

// Material chart options
const options = {
    chart: {
        title: "Company Performance",
        subtitle: "Sales and Expenses over the Years",
    },
};

function BarChart() {
    return (
        <Chart
            chartType="Bar"
            width="100%"
            height="400px"
            data={data}
            options={options}
        />
    );
}

export default BarChart;